"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useReportCommonError = void 0;
var react_1 = require("react");
var keys_1 = require("../../keys");
var useMutation_1 = require("../../useMutation");
var useReportCommonError = function () {
    var _a = (0, useMutation_1.useMutation)({
        path: keys_1.REPORT_COMMON_ERROR,
    }), mutate = _a.mutate, isSubmitting = _a.isSubmitting, error = _a.error;
    return (0, react_1.useMemo)(function () { return ({
        reportCommonError: mutate,
        isSubmitting: isSubmitting,
        error: error,
    }); }, [mutate, isSubmitting, error]);
};
exports.useReportCommonError = useReportCommonError;
